// import React, {Component} from 'react';
import {
  View,
  Text
} from 'react-native';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import c20v1a from './c20v1a'; // 設定情報
import c30v1a from './c30v1a'; // 団体情報
import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報

import i1zv from './i1zv_20211024';

export default class i1zv7 extends i1zv { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stss = { //  子で上書き
  s_i10r_fst: -1, // room
  sn_frc: -1, // frequency
  sn_dow: -1, // day of the week
  s_sttDate: ff.myDT_getDate('today'),
  s_endDate: ff.myDT_add('day', ff.myDT_add('mth', ff.myDT_getDate('today'), 1), -1),
  sl_dates: [],
  sl_times: [],
  s_i1zrt41i: 0,
  s_i30r_fst: -1,
  s_i1zri31s: '',
  s_i1zri32s: -1,
  s_i1zri12s: '',
  s_i1zri12s: '',
  s_i1zri41s: '',
  s_i1zri41i:  0,
  s_i1zrt41i:  0,
  s_i1zri51s: '',
  s_i10r_fst: -1,
  sn_dow: -1,
  sn_frc: -1,
  sdld_i10rListsss: {i10r:[]},
  sdld_i110SlcListsss: {i110:[]},
  sd_frms: {},
};

$clp_loadLists = () => [ // 親を上書き
  cf.myRN_savePageStgs({
    sgc_pageMode: 'new'
  }),
  c20v1a.op_loadDtl({ // 設定
    elm: 'c20r',
  }),
  c30v1a.op_loadSlcList({
    elm: 'c30r',
  }),
  i10v1a.op_loadSlcList({ // 室
    elm:'i10r',
    i10rt11i: 200,
    state: 'sdld_i10rSlcListsss'
  }), // 室・設備
  i10v1a.op_loadSlcList({ // 設備
    elm:'i10r',
    i10rt11i: 400,
    state: 'sdld_i10rSlcListsss2'
  }), // 室・設備

];

$opb_chk = (pb_msg=true) => new Promise( _o_end1 => { // 

  const _o_this = this;

  cf.s();
  ff.myCM_srl([
    () => new Promise( _o_end2 => {
      let _b_chk = false;
      Object.keys(global.t?.state.sd_frms).map( _i10r_fst => {
        Object.keys(global.t?.state.sd_frms[_i10r_fst]).map( _date => {
          Object.keys(global.t?.state.sd_frms[_i10r_fst][_date]).map( _i110_fst => {
            if (global.t?.state.sd_frms[_i10r_fst][_date][_i110_fst] == 1) {
              _b_chk = true;
            }
          })
        })
      })
      if (
        ff.f(global.t?.state.s_sttDate) == false ||
        ff.f(global.t?.state.s_endDate) == false ||
        ff.f(global.t?.state.s_i1zri11s) == false ||
        ff.f(global.t?.state.s_i1zri12s) == false ||
        ff.f(global.t?.state.s_i1zri41s) == false ||
        ff.n(global.t?.state.s_i1zri41i) < 1 ||
        ff.n(global.t?.state.s_i1zrt41i) < 0 ||
        ff.n(global.t?.state.s_i10r_fst) < 0 ||
        _b_chk == false
      ) {
        if (pb_msg) alert('入力されていない項目があるため、指定された操作を行うことができません');
        _o_end2(false);
      } else { _o_end2(true); };
    }),
    () => new Promise( async _o_end2 => {

      let _d_i10rs = global.t?.state.sdld_i10rDtlsss?.i10r[0];
      let _rsvMaxCnt = _d_i10rs.d_flds.i10ri11i;
      let _b_sgl = true;
/*
      const _l = [];
      Object.keys(global.t?.state.sd_frms).map( _i10r_fst => {
        Object.keys(global.t?.state.sd_frms[_i10r_fst]).map( _date => {
          Object.keys(global.t?.state.sd_frms[_i10r_fst][_date]).map( _i110_fst => {
            if ( global.t?.state.sd_frms[_i10r_fst][_date][_i110_fst] == 1 ) {
              const _l2 = [ _i10r_fst, _date, _i110_fst];
              _l.push(_l2);
            };
          });
        });
      });
      for await ( const _l2 of _l ) {
        const _i10r_fst = _l2[0];
        const _date = _l2[2];
        const _i110_fst = _l2[0];
        await i1zv.op_loadSlcList({
          elm: 'i1z0',
          o_cnd: _dd_datss => {
            let _cnd = `t_i1z0.i1z0b41f = ${_i10r_fst} AND t_i1z0.i1z0b51f = ${_i110_fst} AND t_i1z0.i1z0i21d = "${_date}" AND t_i1z0.i1z0s11i IN (70, 80, 90)`;
            _cnd = cf.c('i1z0', _cnd);
            return _cnd;
          },
        })
        .then(() => {
          let _n_cnt = ff.myCM_getLen(global.t?.state.sdld_i1z0SlcListsss.i1z0);
          if (
            _n_cnt >= ff.n(_rsvMaxCnt)
          ) {
            _b_sgl = false;
          }
        })
        await ff.myCM_wait(2) // チェック漏れ予防
      };
*/
      const _rsvRooms = []
      const _rsvDates = []
      const _rsvTimes = []

      Object.keys(global.t?.state.sd_frms).map( _i10r_fst => {
        Object.keys(global.t?.state.sd_frms[_i10r_fst]).map( _date => {
          Object.keys(global.t?.state.sd_frms[_i10r_fst][_date]).map( _i110_fst => {
            if ( global.t?.state.sd_frms[_i10r_fst][_date][_i110_fst] == 1 ) {
              if (ff.i(_i10r_fst, _rsvRooms) == false) _rsvRooms.push(_i10r_fst)
              if (ff.i(_date, _rsvDates) == false) _rsvDates.push(_date)
              if (ff.i(_i110_fst, _rsvTimes) == false) _rsvTimes.push(_i110_fst)
            };
          });
        });
      });

//console.log('i1zv7 194a: ' + JSON.stringify(_rsvDates))
//console.log('i1zv7 194b: ' + JSON.stringify(_rsvTimes))

      await i1zv.op_loadSlcList({
        elm: 'i1z0',
        o_cnd: _dd_datss => {
          let _cnd = `t_i1z0.i1z0b41f = (${_rsvRooms.join(',')}) AND t_i1z0.i1z0b51f in (${_rsvTimes.join(',')}) AND t_i1z0.i1z0i21d in ("${_rsvDates.join('","')}") AND t_i1z0.i1z0s11i IN (70, 80, 90)`;
//console.log('i1zv7 194c: ' + _cnd)
          _cnd = cf.c('i1z0', _cnd);
          return _cnd;
        },
      })
//console.log('i1zv7 194d: ' + JSON.stringify(global.t?.state.sdld_i1z0SlcListsss.i1z0))

      const _cntz = {}
      global.t?.state.sdld_i1z0SlcListsss.i1z0.map((i1z0) => {
        const _dateKey = i1z0.d_flds.i1z0i21d
        const _timeKey = String(i1z0.d_flds.i1z0b51f)
        if (!_cntz[_dateKey]) _cntz[_dateKey] = {}
        if (!_cntz[_dateKey][_timeKey]) _cntz[_dateKey][_timeKey] = 0
        _cntz[_dateKey][_timeKey] += 1
      })
//console.log('i1zv7 194e: ' + JSON.stringify(_cntz))

      Object.keys(global.t?.state.sd_frms).map( _i10r_fst => {
        Object.keys(global.t?.state.sd_frms[_i10r_fst]).map( _date => {
          Object.keys(global.t?.state.sd_frms[_i10r_fst][_date]).map( _i110_fst => {
            if ( global.t?.state.sd_frms[_i10r_fst][_date][_i110_fst] == 1 ) {
              const _dateKey = _date
              const _timeKey = String(_i110_fst)
              //console.log(`i1zv7 198a: ${_dateKey}, ${_timeKey}, ${_rsvMaxCnt}`)
              //console.log(`i1zv7 198b: ${JSON.stringify(_cntz)}`)
              if (
                ff.n(_cntz?.[_dateKey]?.[_timeKey]) >= ff.n(_rsvMaxCnt)
              ) {
                _b_sgl = false;
              }
            };
          });
        });
      });
//console.log('i1zv7 194f: ' + _b_sgl)

//      _b_sgl = false // for dev
      if (
        _b_sgl == false
      ) {
        if (pb_msg) alert(`指定した室の時間帯に他の予約があるため、指定された操作を行うことができません`); 
        _o_end2(false);
      } else { _o_end2(true); };
    }),

    () => new Promise( async _o_end2 => {
      // 設備の確認
      let _ld_i1z2ss = global.t?.state.sdld_i1z2Listsss?.i1z2?.filter( _d_i1z2s => (_d_i1z2s.b_dlt != true) ? true : false);
      if (ff.myCM_getLen(_ld_i1z2ss) > 0 ) { // 設備が設定されている場合

        let _b_sgl = true;
        const _l = [];
        Object.keys(global.t?.state.sd_frms).map( _i10r_fst => {
          Object.keys(global.t?.state.sd_frms[_i10r_fst]).map( _date => {
            Object.keys(global.t?.state.sd_frms[_i10r_fst][_date]).map( _i110_fst => {
              if ( global.t?.state.sd_frms[_i10r_fst][_date][_i110_fst] == 1 ) {
                const _l2 = [ _i10r_fst, _date, _i110_fst];
                _l.push(_l2);
              };
            });
          });
        });
        for await ( const _l2 of _l ) {
          const _rsvDate = _l2[1];
          const _i110_fst = _l2[2];
          await Promise.all(
            _ld_i1z2ss.map( _d_i1z2s => new Promise( _o_end3 => {
              let _rsvFly = _d_i1z2s.d_flds.i1z2b41f; // 設備
              let _rsvMaxCnt = _d_i1z2s.d_flds.i10ri11i; // 許容件数
              Promise.all(
                global.t?.state.sdld_i110SlcListsss?.i110.map( _d_i110s => new Promise( _o_end4 => {
                  if (_d_i110s.d_flds._fst == _i110_fst) { // 選択した時間帯のみチェック
                    let _rsvSttTime = _d_i110s.d_flds.i110i11t;
                    let _rsvEndTime = _d_i110s.d_flds.i110i12t;
                    i1zv.op_loadSlcList({
                      elm: 'i1z0',
                      o_cnd: _dd_datss => {
                        let _cnd1 = cf.c('i110', `i110i11t::NUMERIC::INTEGER < ${_rsvEndTime}  AND ${_rsvSttTime} < i110i12t::NUMERIC::INTEGER`);
                        let _cnd2 = cf.c('i1z2', `i1z2b41f = ${_rsvFly} AND i1z2b61k = i1z0b61k`);
                        let _cnd = `(SELECT COUNT(*) FROM t_i1z2 WHERE ${_cnd2}) > 0 AND t_i1z0.i1z0b51f IN (SELECT _fst FROM t_i110 WHERE ${_cnd1}) AND t_i1z0.i1z0i21d = "${_rsvDate}" AND t_i1z0.i1z0s11i IN (70, 80, 90)`;
                        _cnd = cf.c('i1z0', _cnd);
                        return _cnd;
                      },
                    })
                    .then(() => {
                      let _n_cnt = ff.myCM_getLen(global.t?.state.sdld_i1z0SlcListsss.i1z0);
                      if (
                        _n_cnt >= ff.n(_rsvMaxCnt)
                      ) {
                        _b_sgl = false;
                        _o_end4();
                      }
                      else {
                        _o_end4();
                      };
                    })
                  }
                  else {
                    _o_end4();
                  }

                }))
              )
              .then(() => {
                _o_end3();
              });
            }))
          )

        };

        if (
          _b_sgl == false
        ) {
          if (pb_msg) alert(`指定した設備の時間帯に他の予約があるため、指定された操作を行うことができません`); 
          _o_end2(false);
        } else { _o_end2(true); };
      } else { _o_end2(true); };
    }),

  ])
  .then( _b_res => {
    cf.myRN_setStt({
      sgcb_chk: _b_res,
    })
    .then(() => {
      cf.h();
      _o_end1(_b_res);
    });
  });
}) 

_op_loadCdr = () => new Promise( _o_end1 => {
  let _sttDate = global.t?.state.s_sttDate;
  let _endDate = ff.myDT_add('day', ff.myDT_add('mth', _sttDate, 1), -1);
  global.t?.setState({
    s_endDate: _endDate
  });

  let _l_i10r_fsts = [];
  let _fst = global.t?.state.s_i10r_fst; // 室
  if (_fst > 0) _l_i10r_fsts.push(_fst); // 設備
  global.t?.state.sdld_i1z2Listsss?.i1z2
  .filter( _d_i1z2s => (_d_i1z2s.b_dlt != true) ? true : false )
  .map( _d_i1z2s => {
    let _fst = _d_i1z2s.d_flds.i1z2b41f;
    if (_fst > 0) {
      _l_i10r_fsts.push(_fst);
    }
  });

  if ( 
    ff.f(_l_i10r_fsts) == true && // 設備単体を削除した場合、表示が更新されない模様
    ff.f(_sttDate) && 
    ff.f(_endDate) && 
    _sttDate <= _endDate 
  ) {
    i1zv.op_updHdys({
      sttDate: _sttDate,
      endDate: _endDate,
    })
    .then(() => {
      let _l_dates = ff.myDT_cnv('dates', { // 指定した期間における日付の一覧
        stt: _sttDate,
        end: _endDate,
      });
      cf.myRN_setStt({
        sl_dates: _l_dates,
      })
      .then(() => {
        let _dates = ff.myCM_cnv('list-csv', { list: _l_dates, dlm: '"' });
        cf.s();
        i10v1a.op_loadList({
          elm: 'i10r',
          o_cnd: _dd_datss => {
            let _cnd = ff.myCM_cnv('list-csv', { list: _l_i10r_fsts, dlm: '' });
            _cnd = cf.c('i10r', `_fst IN (${_cnd})`)
            return _cnd;
          },
          dd_cldDefss: {
            i110: {
              elm: 'i110',
              o_cnd: _dd_datss => {
                let _cnd = cf.c('i110', `i110b51k = (SELECT _key FROM t_i11r WHERE ${cf.c('i11r', `t_i11r._fst = ${_dd_datss.i10r.d_flds.i10rb51f}`)})`) // 指定した利用日に紐づく予約情報
                return _cnd;
              },
              dd_cldDefss: {
                i1zr: {
                  elm: 'i1zr',
                  o_cnd: _dd_datss => {
                    let _cnd = cf.c('i1zr', `i1zrb41f = ${_dd_datss.i10r.d_flds._fst} AND i1zri21d IN (${_dates}) AND i1zrs11i IN (70, 80, 90)`) // 指定した利用日に紐づく予約情報
                    return _cnd;
                  },
                  dd_cldDefss: {
                    i1z0: {
                      elm: 'i1z0',
                      o_cnd: _dd_datss => {
                        let _cnd = cf.c('i1z0', `i1z0b61k = ${_dd_datss.i1zr.d_flds._key} AND i1z0b51f = ${_dd_datss.i110.d_flds._fst}`, false, false) // 指定した利用日に紐づく予約情報
                        return _cnd;
                      },
                    },
                  },
                },
              },
            },
          },
          op_atrAll: () => new Promise( async _o_end2 => { 

            let _ld_i110ss = global.t?.state.sdld_i110SlcListsss?.i110; // 室の時間帯区分

            let _ddd_dtlsss = {};

            for await (let [_idxI1z2, _d_i1z2s] of ff.e(global.t?.state.sdld_i1z2Listsss?.i1z2)) { // 処理対象は設備のみ
              let _i10r_fst = `${_d_i1z2s.d_flds.i1z2b41f}`;
              let _cnd = cf.c(`i1z2`, `i1z2b61k = i1z0b61k AND i1z2b41f = ${_i10r_fst}`);
              _cnd = cf.c(`i1z0`, `(i1z0i21d >= "${_sttDate}" AND "${_endDate}" >= i1z0i21d) AND EXISTS (SELECT * FROM t_i1z2 WHERE ${_cnd}) AND EXISTS ( SELECT * FROM t_i1zr WHERE COALESCE(i1zrcz1i,10) <> 0 AND i1zrs11i IN (70, 80, 90) AND t_i1zr._key = i1z0b61k )`);
              await cf.myCB_call_slc({
                elm: 'i1z0',
                n_dms: 3,
                cnd: _cnd,
                dd_rfrss: {
                  i1zr: {
                    elm: 'i1zr',
                    o_cnd: _d_flds => {
                      let _cnd = cf.c(`i1zr`, `_key = ${_d_flds.i1z0b61k}`, false, false);
                      return _cnd;
                    },
                  },
                  i110: {
                    elm: 'i110',
                    o_cnd: _d_flds => {
                      let _cnd = cf.c(`i110`, `_fst = ${_d_flds.i1z0b51f}`);
                      return _cnd;
                    },
                  },
                  i1z2: {
                    elm: 'i1z2',
                    o_cnd: _d_flds => {
                      let _cnd = cf.c(`i1z2`, `i1z2b61k = ${_d_flds.i1z0b61k} AND i1z2b41f = ${_i10r_fst}`);
                      return _cnd;
                    },

                    dd_rfrss: {
                      i10r: {
                        elm: 'i10r',
                        o_cnd: _d_flds => {
                          let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1z2b41f}`);
                          return _cnd;
                        },
                      }
                    },

                  }
                },
                d_cashs: {},
              })
              .then( _ld_fldss => {
                _ld_fldss.map( _d_flds => {
                  let _date = _d_flds.i1z0i21d;
                  let _n_maxCnt = ff.n(_d_flds.i10ri11i);
                  _ld_i110ss.map( _d_i110s => {
                    let _i110c31s = _d_i110s.d_flds.i110c31s;
                    if (!_ddd_dtlsss[_i10r_fst]) _ddd_dtlsss[_i10r_fst] = {};
                    if (!_ddd_dtlsss[_i10r_fst][_i110c31s]) _ddd_dtlsss[_i10r_fst][_i110c31s] = {};
                    if (
                      ff.n(_d_i110s.d_flds.i110i12t) > ff.n(_d_flds.i110i11t) &&
                      ff.n(_d_flds.i110i12t) > ff.n(_d_i110s.d_flds.i110i11t)
                    ) {
                      if (!_ddd_dtlsss[_i10r_fst][_i110c31s][_date]) _ddd_dtlsss[_i10r_fst][_i110c31s][_date] = { n_cnt: 0, pfx: '' };
                      _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_cnt += 1;
                      if (_ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_cnt >= _n_maxCnt) {
                        _ddd_dtlsss[_i10r_fst][_i110c31s][_date].pfx = 'x'; // 設備
                      };
                    };
                  })
                });
              });
            }

            let _state = 'sdld_i10rListsss';
            if (global.t?.state[_state]) {
              global.t?.setState({
                [_state]: bf.p(global.t?.state[_state], _next => {

                  _next.i10r.map( (_d_i10rs, _idxI10r) => {
                    _d_i10rs.d_tbls = { pfx: _d_i10rs.d_flds.i10rc31s, d_is: {} }; //category
                    const _i10r_fst = _d_i10rs.d_flds._fst; // 室 fst                 
                    let _n_maxCnt = _d_i10rs.d_flds.i10ri11i;

                    if (_d_i10rs.d_flds.i10rt11i == 200) { // 室の場合
                      _d_i10rs.dld_cldDatsss.i110.map( (_d_i110s, _i110Idx) => { // ctg
                        const _i110s_fst = _d_i110s.d_flds._fst; // 時間帯 fst
                        const _i110c31s = _d_i110s.d_flds.i110c31s; // 時間帯 fst
                        _d_i110s.d_tbls = { pfx: _d_i110s.d_flds.i110c31s, d_is: {} };
                        _d_i110s.dld_cldDatsss.i1zr.map( (_d_i1zrs, _i1zrIdx) => { // dtl
                          let _date = _d_i1zrs.d_flds.i1zri21d;
                          if (ff.f(_d_i110s.d_tbls.d_is[_date]) == false) _d_i110s.d_tbls.d_is[_date] = { n_cnt: 0, pfx:'' }
                          _d_i1zrs.dld_cldDatsss?.i1z0.map( (_d_i1z0s, _i1z0Idx) => {
                            _d_i110s.d_tbls.d_is[_date].n_cnt += 1;
                            if (_d_i110s.d_tbls.d_is[_date].n_cnt >= _n_maxCnt) {
                              _d_i110s.d_tbls.d_is[_date].pfx = 'x'; // 室
                            }
                          });
                        });

                        _l_dates.map( _date => {
                          if (ff.f(_d_i110s.d_tbls.d_is[_date]?.pfx) == false) {

                            let _b_sgl = true;
                            global.t?.state[_state].i10r.map( _d_i10rs2 => { // 設備の空き状況の確認
                              if (_d_i10rs2.d_flds.i10rt11i == 400) { // 設備の場合
                                const _i10r_fst2 = _d_i10rs2.d_flds._fst;
                                if (
                                  _ddd_dtlsss[_i10r_fst2] && 
                                  _ddd_dtlsss[_i10r_fst2][_i110c31s] && 
                                  _ddd_dtlsss[_i10r_fst2][_i110c31s][_date] && 
                                  ff.f(_ddd_dtlsss[_i10r_fst2][_i110c31s][_date].pfx)
                                ) {
                                  _b_sgl = false;
                                };
                              }
                            });

                            if (_b_sgl) {
                              if (ff.f(_d_i110s.d_tbls.d_is[_date]) == false) _d_i110s.d_tbls.d_is[_date] = { n_cnt: 0, pfx:'' }
                              _d_i110s.d_tbls.d_is[_date].cld = (
                                ce.c(ce.Chk, {
                                  key: -10,
                                  frm: 'sqr',
                                  d_stlChks: {
                                    height: ic.s(1.0),
                                    width: ic.s(1.0),
                                  },
                                  o_onChg: _b => {
                                    global.t?.setState({
                                      sd_frms: bf.p(global.t?.state.sd_frms, _next => {
                                        if (ff.f(_next[_i10r_fst]) == false) _next[_i10r_fst] = { [_date]: { [_i110s_fst]: _b } };
                                        if (ff.f(_next[_i10r_fst][_date]) == false) _next[_i10r_fst][_date] = { [_i110s_fst]: _b };
                                        _next[_i10r_fst][_date][_i110s_fst] = _b;
                                      })
                                    });
                                  },
                                }) // 室
                              );
                            }
                          };
                        });

                      })
                    };
                    
                    if (_d_i10rs.d_flds.i10rt11i == 400) { // 設備の場合
                      _d_i10rs.dld_cldDatsss.i110 = [];
                      let _i10r_fst = `${_d_i10rs.d_flds._fst}`;
                      if (_ddd_dtlsss[_i10r_fst]) Object.keys(_ddd_dtlsss[_i10r_fst]).map( _i110c31s => {
                        let _dd_dtlss = _ddd_dtlsss[_i10r_fst][_i110c31s];
                        _d_i10rs.dld_cldDatsss.i110.push( { d_tbls: { pfx: _i110c31s, d_is: _dd_dtlss} } );
                      })
                    };

                  })
                }),
              }, () => {
                cf.h();
                _o_end2();
              });
            }
            else {
              cf.h();
              _o_end2();
            }
          }),
        })
      });
      _o_end1();
    });
  }
  else {
    _o_end1();
  };
});

_op_onChgC30r_fst = (pd={ // 団体情報の反映
}) => new Promise( _o_end1 => { 
  if (global.t?.state.s_c30r_fst > 0) {
    cf.s();
    c30v1a.op_loadDtl({
      elm: 'c30r',
      fst: global.t?.state.s_c30r_fst,
    })
    .then(() => {
      let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0]; 
      cf.myRN_setStt({
        s_i1zri31s: _d_c30rs.d_flds.c30ri11s, // 代表者
        s_i1zri32s: _d_c30rs.d_flds.c30ri21s, // 利用制限
        s_i1zri11s: _d_c30rs.d_flds.c30ri11s, // 申込者
        s_i1zri12s: _d_c30rs.d_flds.c30ri41s, // 連絡先
      })
      .then(() => {
        cf.h();
        _o_end1();
      });
    })
  }
  else {
    _o_end1();
  };
});

$clp_upds = () => [
  new Promise( async _o_end1 => {

    let _d_i10rs = global.t?.state.sdld_i10rDtlsss?.i10r[0];
/*
    for await (let [_idx, _date] of ff.e(global.t?.state.sl_dates)) {

      await cf.myRN_setStt({ // 重複登録を抑制するため初期化
        sdld_i1zrDtlsss: {},
      });

      let _d_i1zrFlds = {
        i1zrb31f: global.t?.state.s_c30r_fst ?? -1,
        i1zrb41f: global.t?.state.s_i10r_fst ?? -1,
        i1zrt11i: 0,
        i1zrt21i: global.t?.state.s_i1zrt21i ?? -1,
        i1zrc11s: '-',
        i1zrs11i: (global.t?.state.s_c30r_fst > 0) ? 80 : 70,
        i1zrs21i: 0,
        i1zrs22i: 0,
        i1zri11d: ff.myDT_getDate('today'),
        i1zri21d: _date,
        i1zri11s: global.t?.state.s_i1zri11s ?? '',
        i1zri12s: global.t?.state.s_i1zri12s ?? '',
        i1zri31s: global.t?.state.s_i1zri31s ?? '',
        i1zri32s: global.t?.state.s_i1zri32s ?? '0',
        i1zrt41i: global.t?.state.s_i1zrt41i ?? -1,
        i1zri41s: global.t?.state.s_i1zri41s ?? '',
        i1zri41i: global.t?.state.s_i1zri41i ??  0,
        i1zri11m: global.t?.state.s_i1zri11m ??  0,
        i1zri51s: global.t?.state.s_i1zri51s ?? '',
      };
      let _d_i1zrDats = cf.myRN_crtDats({
        elm: 'i1zr',
        d_insFlds: _d_i1zrFlds,
      });
      await cf.myRN_addDats({
        state: 'sdld_i1zrDtlsss',
        als: 'i1zr',
        d_dats: _d_i1zrDats,
      })
      .then(async () => {

        let _time = '';
        for await ( let [_i110Idx, _d_i110s] of ff.e(global.t?.state.sdld_i110SlcListsss?.i110)) { // 利用日時
          let _n_chk = global.t?.state[`s_time${_d_i110s.d_flds._fst}`];
          if (_n_chk == 1) { // 選択されている場合
            let _d_i1z0Flds = {
              i1z0b31f: global.t?.state.s_c30r_fst ?? -1, // 親要素と同値
              i1z0b41f: global.t?.state.s_i10r_fst ?? -1, // 親要素と同値
              i1z0b51f: _d_i110s.d_flds._fst ?? -1,
              i1z0b61k: global.t?.state.sgc_pageKey ?? -1,
              i1z0i21d: _date, // 親要素と同値
              i1z0s11i: (global.t?.state.s_c30r_fst > 0) ? 80 : 70, // 親要素と同値
              i1z0i11m: _d_i10rs.d_flds.i10ri11m ?? 0,
              i1z0i12m: _d_i10rs.d_flds.i10ri11m ?? 0,
              i1z0i11i: 1,
              i1z0t11i: global.t?.state.s_i1z0t11i ?? -1,
              i1z0i21s: global.t?.state.s_i1z0i21s ?? '',
              i1z0i31i: global.t?.state.s_i1z0i31i ?? 0,
            };
            let _d_i1z0Dats = await cf.myRN_crtDats({
              elm: 'i1z0',
              d_insFlds: _d_i1z0Flds,
            });
            await cf.myRN_addDats({
              state: 'sdld_i1zrDtlsss',
              als: 'i1z0',
              d_dats: _d_i1z0Dats,
              d_prtDats: _d_i1zrDats,
            })
            _time += (ff.f(_time) ? ',' : '') + _d_i110s.d_flds._fst;
          }
        }

        for await ( let [_i1z2Idx, _d_i1z2s] of ff.e(global.t?.state.sdld_i1z2Listsss?.i1z2)) { // 設備
          if (_d_i1z2s.b_dlt != true) { // 削除されてない場合
            let _d_i1z2Flds = {
              i1z2b41f: _d_i1z2s.d_flds.i1z2b41f ?? -1, // 親要素と同値
              i1z2b61k: global.t?.state.sgc_pageKey ?? -1,
              i1z2i12m: _d_i1z2s.d_flds.i1z2i12m ?? 0,
            };
            let _d_i1z2Dats = await cf.myRN_crtDats({
              elm: 'i1z2',
              d_insFlds: _d_i1z2Flds,
            });
            await cf.myRN_addDats({
              state: 'sdld_i1zrDtlsss',
              als: 'i1z2',
              d_dats: _d_i1z2Dats,
              d_prtDats: _d_i1zrDats,
            })
          }
        };

        await global.t?._op_updI1z1i31m(); // 支払額計の更新
        await i1zv._updI1zrDtl()

        if ( ff.n(global.t?.state.sgcd_stgs._00050310) == 10 ) {
          const _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0]; 
          const _cnd = cf.c('i1zr', `i1zrb31f=${global.t?.state.s_c30r_fst} AND i1zrb41f=${global.t?.state.s_i10r_fst} AND i1zri21d="${_date}" AND EXISTS (SELECT * FROM t_i1z0 WHERE i1z0b61k = t_i1zr._key AND i1z0b51f IN (${_time}))`);
          await i1zv.op_loadDtl({
            elm: 'i1zr',
            o_cnd: () => _cnd,
          })
          const _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
          let _ttl = 
            `ご予約を受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`;
          let _msg = 
`団体番号：${_d_c30rs.d_flds.c30rc11s}
${_d_c30rs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記ご予約を受け付けましたので、ご連絡致します。
なお、本ご予約を変更する場合は、キャンセルした後、改めてご予約ください。

<<< ご予約内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------
${global.t?.state.sgcd_stgs._01050100}

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
            const _l_tos = [];
            if (ff.f(_d_c30rs.d_flds.c30rig1s)) _l_tos.push(_d_c30rs.d_flds.c30rig1s);
            if (ff.f(_d_c30rs.d_flds.c30rig2s)) _l_tos.push(_d_c30rs.d_flds.c30rig2s);
            if (ff.f(_d_c30rs.d_flds.c30rig3s)) _l_tos.push(_d_c30rs.d_flds.c30rig3s);
            const _l_bccs = [ic.g_mail];
            if (ff.f(global.t?.state.sgcd_stgs._00050200)) _l_bccs.push(global.t?.state.sgcd_stgs._00050200);                                  
            await cf.myCB_call_eml(
              _l_tos,
              _ttl,
              _msg,
              _l_bccs
            )
        };
      })

    }
*/

    const _dl_i110ss = {};
    Object.keys(global.t?.state.sd_frms).map( _i10r_fst => {
      Object.keys(global.t?.state.sd_frms[_i10r_fst]).map( _date => {
        const _l_i110s = [];
        Object.keys(global.t?.state.sd_frms[_i10r_fst][_date]).map( _i110_fst => {
          if (global.t?.state.sd_frms[_i10r_fst][_date][_i110_fst] == 1) {
            _l_i110s.push(_i110_fst);
          }
        });
        if (ff.f(_l_i110s)) {
          _dl_i110ss[_date] = _l_i110s;
        };
      })
    })
    

    for await (let [_idx, _date] of Object.keys(_dl_i110ss).entries()) {

      const _l_i110s = _dl_i110ss[_date];
//ff.l('i1zv7 684: {}, {}'.f(_date, _l_i110s));

      await cf.myRN_setStt({ // 重複登録を抑制するため初期化
        sdld_i1zrDtlsss: {},
      });

      let _d_i1zrFlds = {
        i1zrb31f: global.t?.state.s_c30r_fst ?? -1,
        i1zrb41f: global.t?.state.s_i10r_fst ?? -1,
        i1zrt11i: 0,
        i1zrt21i: global.t?.state.s_i1zrt21i ?? -1,
        i1zrc11s: '-',
        i1zrs11i: (global.t?.state.s_c30r_fst > 0) ? 80 : 70,
        i1zrs21i: 0,
        i1zrs22i: 0,
        i1zri11d: ff.myDT_getDate('today'),
        i1zri21d: _date,
        i1zri11s: global.t?.state.s_i1zri11s ?? '',
        i1zri12s: global.t?.state.s_i1zri12s ?? '',
        i1zri31s: global.t?.state.s_i1zri31s ?? '',
        i1zri32s: global.t?.state.s_i1zri32s ?? '0',
        i1zrt41i: global.t?.state.s_i1zrt41i ?? -1,
        i1zri41s: global.t?.state.s_i1zri41s ?? '',
        i1zri41i: global.t?.state.s_i1zri41i ??  0,
        i1zri11m: global.t?.state.s_i1zri11m ??  0,
        i1zri51s: global.t?.state.s_i1zri51s ?? '',
      };
      let _d_i1zrDats = cf.myRN_crtDats({
        elm: 'i1zr',
        d_insFlds: _d_i1zrFlds,
      });
//ff.l('i1zv7 719: {}'.f(_d_i1zrDats));
      await cf.myRN_addDats({
        state: 'sdld_i1zrDtlsss',
        als: 'i1zr',
        d_dats: _d_i1zrDats,
      })
      .then(async () => {
//ff.l('i1zv7 726: here');

        let _time = '';
        for await ( let [_i110Idx, _d_i110s] of ff.e(global.t?.state.sdld_i110SlcListsss?.i110)) { // 利用日時
//ff.l('i1zv7 730: {}, {}'.f(_d_i110s?.d_flds?._fst, _l_i110s));
          if (ff.i(String(_d_i110s?.d_flds?._fst), _l_i110s)) { // 選択されている場合
//ff.l('i1zv7 732: here');
            let _d_i1z0Flds = {
              i1z0b31f: global.t?.state.s_c30r_fst ?? -1, // 親要素と同値
              i1z0b41f: global.t?.state.s_i10r_fst ?? -1, // 親要素と同値
              i1z0b51f: _d_i110s.d_flds._fst ?? -1,
              i1z0b61k: global.t?.state.sgc_pageKey ?? -1,
              i1z0i21d: _date, // 親要素と同値
              i1z0s11i: (global.t?.state.s_c30r_fst > 0) ? 80 : 70, // 親要素と同値
              i1z0i11m: _d_i10rs.d_flds.i10ri11m ?? 0,
              i1z0i12m: _d_i10rs.d_flds.i10ri11m ?? 0,
              i1z0i11i: 1,
              i1z0t11i: global.t?.state.s_i1z0t11i ?? -1,
              i1z0i21s: global.t?.state.s_i1z0i21s ?? '',
              i1z0i31i: global.t?.state.s_i1z0i31i ?? 0,
            };
//ff.l('i1zv7 747: here');
            let _d_i1z0Dats = await cf.myRN_crtDats({
              elm: 'i1z0',
              d_insFlds: _d_i1z0Flds,
            });
//ff.l('i1zv7 752: {}'.f(_d_i1z0Dats));
            await cf.myRN_addDats({
              state: 'sdld_i1zrDtlsss',
              als: 'i1z0',
              d_dats: _d_i1z0Dats,
              d_prtDats: _d_i1zrDats,
            })
            _time += (ff.f(_time) ? ',' : '') + _d_i110s.d_flds._fst;
          }
        }

        for await ( let [_i1z2Idx, _d_i1z2s] of ff.e(global.t?.state.sdld_i1z2Listsss?.i1z2)) { // 設備
          if (_d_i1z2s.b_dlt != true) { // 削除されてない場合
            let _d_i1z2Flds = {
              i1z2b41f: _d_i1z2s.d_flds.i1z2b41f ?? -1, // 親要素と同値
              i1z2b61k: global.t?.state.sgc_pageKey ?? -1,
              i1z2i12m: _d_i1z2s.d_flds.i1z2i12m ?? 0,
            };
            let _d_i1z2Dats = await cf.myRN_crtDats({
              elm: 'i1z2',
              d_insFlds: _d_i1z2Flds,
            });
//ff.l('i1zv7 770: {}'.f(_d_i1z2Dats));
            await cf.myRN_addDats({
              state: 'sdld_i1zrDtlsss',
              als: 'i1z2',
              d_dats: _d_i1z2Dats,
              d_prtDats: _d_i1zrDats,
            })
          }
        };

        await global.t?._op_updI1z1i31m(); // 支払額計の更新
        await i1zv._updI1zrDtl()

        if ( ff.n(global.t?.state.sgcd_stgs._00050310) == 10 ) {
          const _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0]; 
          const _cnd = cf.c('i1zr', `i1zrb31f=${global.t?.state.s_c30r_fst} AND i1zrb41f=${global.t?.state.s_i10r_fst} AND i1zri21d="${_date}" AND EXISTS (SELECT * FROM t_i1z0 WHERE i1z0b61k = t_i1zr._key AND i1z0b51f IN (${_time}))`);
          await i1zv.op_loadDtl({
            elm: 'i1zr',
            o_cnd: () => _cnd,
          })
          const _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
          let _ttl = 
            `ご予約を受け付けました (ID：${_d_i1zrs.d_flds.i1zrc11s})(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`;
          let _msg = 
`団体番号：${_d_c30rs.d_flds.c30rc11s}
${_d_c30rs.d_flds.c30rc31s}　様
-------------------------------------------------
ご利用いただきまして誠にありがとうございます。
下記ご予約を受け付けましたので、ご連絡致します。
なお、本ご予約を変更する場合は、キャンセルした後、改めてご予約ください。

<<< ご予約内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------
${global.t?.state.sgcd_stgs._01050100}

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`;
            const _l_tos = [];
            if (ff.f(_d_c30rs.d_flds.c30rig1s)) _l_tos.push(_d_c30rs.d_flds.c30rig1s);
            if (ff.f(_d_c30rs.d_flds.c30rig2s)) _l_tos.push(_d_c30rs.d_flds.c30rig2s);
            if (ff.f(_d_c30rs.d_flds.c30rig3s)) _l_tos.push(_d_c30rs.d_flds.c30rig3s);
            const _l_bccs = [ic.g_mail];
            if (ff.f(global.t?.state.sgcd_stgs._00050200)) _l_bccs.push(global.t?.state.sgcd_stgs._00050200);                                  
//ff.l('i1zv7 821: {}, {}, {}, {}'.f(_l_tos, _ttl, _msg, _l_bccs));
            await cf.myCB_call_eml(
              _l_tos,
              _ttl,
              _msg,
              _l_bccs
            )
        };
      })

    }

    _o_end1();
  }),
];

render() {

  let _r = [];

  global.t?.state.sdld_i110SlcListsss?.i110.map( (_d_i110s, _i110Idx) => { // 時間帯の設定
    const _state = `s_time${_d_i110s.d_flds._fst}`;
    _r.push(
      ce.c(ce.Chk, {
        key: _i110Idx,
        frm: 'sqr',
        bsd: _d_i110s.d_flds.i110c31s,
        state: _state,
        n_val: 0,
        b_edit: true,
        b_row: true,
        n_col: 5,
        o_onChg: _n_res => {
          cf.myRN_setStt({
            [_state]: _n_res,
          })
        }
      }),
    );
  });

  let _r2 = [];
  if (ff.f(global.t?.state.sdld_i10rListsss?.i10r)) {
    let _state = `sdld_i10rListsss`;
    let _n_lblW = ic.s(2 * 4);
    let _n_cnt = ff.myCM_getLen(global.t?.state.sl_dates);
    let _n_w1 = (ic.gn_bdyW - _n_lblW) / _n_cnt;
    _r2.push(
      ce.c(ce.Tbl2, {
        key: `Tbl`,
        pfx: '予約状況',
        b_vsb: true,
        b_ctg: true,
        b_tgt: true,
        state: _state,
        l_cmns: global.t?.state.sl_dates,
        o_hat: _cmn => 
          (_cmn == global.t?.state.s_sttDate || ff.myDT_cnv('day', _cmn) == 1) ?
          `${ff.myDT_cnv('mth', _cmn)}`
          : null,
        o_pfx: _cmn => `${ff.myDT_cnv('day', _cmn)}`,
        o_sfx: _cmn => {
          let _s = 
            ff.i( _cmn, global.t?.state.sl_hdys ) ?
              '休'
            : `${ff.myDT_cnv('dow', _cmn)}`;
          return _s;
        }, 
        od_stlLbls: () => {
          let _d = 
            {
              width: _n_lblW,
              backgroundColor: ic.o_getCcd('h'),
              paddingLeft: ic.m(1),
              paddingRight: ic.m(1),
            };
          return _d;
          
        },
        od_stlCells: (_cmn, _cmnIdx) => {          
          let _d = {
            flex: _n_w1,
            backgroundColor:
              ff.i( _cmn, global.t?.state.sl_hdys ) ?
                ic.g_ccdHN 
              : ((_cmnIdx + 1) % 2 == 0) ? 
                ic.o_getCcd('h') 
              : ic.g_ccdWN,
          };
          return _d;
        },
        od_stlCtgRows: () => {          
          let _d = {
            minHeight: ic.s(2),
          };
          return _d;
        },
        od_stlDtlRows: () => {          
          let _d = {
              minHeight: ic.s(2),
          };
          return _d;
        },
      })
    );
  };

  let _r3 = [];
  if ( ff.n(global.t?.state.sgcd_stgs?._00070100) == 10 ) { // 設備を使用する場合
    _r3 = global.t?._o_rdrFly2();
  };

  return (
    ce.c(ce.RootDtl, 
      /* ----------------------------------------------------------------------------------------------------
      スタッフ用 予約一括登録
      ---------------------------------------------------------------------------------------------------- */
      {
        key: -1,
        d_hdrs: {
          pfx: '月間予約一括登録',
          d_lefts: {
            b_vsb: false,
          },
        },

        d_bdys: {
          l_clds: [

            /* ----------------------------------------------------------------------------------------------------
            変更
            ---------------------------------------------------------------------------------------------------- */
            ce.c(ce.Pnl, {
              key: -1,
              mode: 'list',
              b_vsb: global.t?.state.sgc_pnlMode == 'list' ? true : false,
              d_hdrs: {
                b_vsb: false,
              },
              d_bdys: {
                d_msgBfrs: {
                  pfx: `■右肩に×のある欄･･･空欄を押すと選択肢が表示され、×で選択を取り消します。\n■【各室の予約状況】･･･希望する「室」と「利用日時」を選択するとカレンダーが表示されます。 ×の日時は予約できません。`,
                  n_mgnTop: ic.s(1),
                  d_stlCtas: {
                    minWidth: ic.gn_bdyW,
                  },
                },
                l_clds: [

                  ce.c(ce.Box, {
                    key: -10,
                    n_mgnTop: ic.s(1),
                    d_stlCtas: {
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start'
                    }
                  }, [

                    ce.c(ce.Row, {
                      key: -10,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(0.2),
                    }, [
                      ce.c(ce.Row, {
                        key: -10,
                        n_w: ic.s(21),
                      }, [
                        ce.c(ce.PckDate, {
                          key: -10,
                          pfx: '登録期間',
                          state: 's_sttDate',
                          b_edit: true,
                          b_row: true,
                          n_col: 8,
                          o_onChg: global.t?._op_loadCdr,
                          d_stlLblCtas: {
                            width: ic.s(5),
                          },
                        }),
                        ce.c(ce.PckDate, {
                          key: -20,
                          pfx: '〜',
                          state: 's_endDate',
//                          b_edit: true,
                          b_edit: false,
                          b_row: true,
                          n_col: 8,
                          o_onChg: global.t?._op_loadCdr,
                          d_stlLblCtas: {
                            width: ic.s(1)
                          },
                        }),
                      ]),
                    ]),

                    ce.c(ce.Row, {
                      key: -20,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(0.2),
                    }, [
                      ce.c(ce.PckSch, {
                        key: -10,
                        pfx: '団体',
                        state: 's_c30r_fst',
                        b_edit: true,
                        b_row: true,
                        n_col: 10,
                        ld_iss: global.t?.state.sdld_c30rSlcListsss?.c30r,
                        o_onChg: _d_dats => {
                          global.t?._op_onChgC30r_fst();
                        },
                        n_w: ic.s(21+1),
                        d_lbls: {
                          d_stlCtas: {
                            width: ic.s(5),
                          },
                          d_stlPfxs: {
                            textAlign: 'center',
                          },
                        },
                      }),
                      ce.c(ce.Inp, {
                        key: -20,
                        pfx: '代表者',
                        state: 's_i1zri31s',
                        b_edit: false,
                        b_row: true,
                        n_w: ic.s(21+1),
                        d_stlLblCtas: {
                          width: ic.s(6),
                        },
                        d_stlLblPfxs: {
                          textAlign: 'center',
                        },
                      }),
                      ce.c(ce.Pck, cf.f('i1zri32s', {
                        key: -30,
                        pfx: '利用制限',
                        state: 's_i1zri32s',
                        b_edit: false,
                        b_row: true,
                        n_w: ic.s(21),
                        d_stlLblCtas: {
                          width: ic.s(5),
                        },
                        d_stlLblPfxs: {
                          textAlign: 'center',
                        },
                      })),
                    ]),

                    ce.c(ce.Row, {
                      key: -30,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(0.2),
                    }, [
                      ce.c(ce.Inp, cf.f('i1zri11s', {
                        key: -10,
                        pfx: '申込者',
                        state: 's_i1zri11s',
                        b_edit: true,
                        b_row: true,
                        n_w: ic.s(21+1),
                        d_stlLblCtas: {
                          width: ic.s(5),
                        },
                        d_stlLblPfxs: {
                          textAlign: 'center',
                        },
                      })),
                      ce.c(ce.Inp, cf.f('i1zri12s', {
                        key: -20,
                        pfx: '電話番号',
                        state: 's_i1zri12s',
                        b_edit: true,
                        b_row: true,
                        n_w: ic.s(21+1),
                        d_lbls: {
                          d_stlCtas: {
                            width: ic.s(6),
                          },
                          d_stlPfxs: {
                            textAlign: 'center',
                          },
                        },
                      })),
                    ]),
                    ce.c(ce.Row, {
                      key: -35,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(0.2),
                    }, [
                      ce.c(ce.Inp, cf.f('i1zri41s', {
                        key: -10,
                        pfx: '内容',
                        state: 's_i1zri41s',
                        b_edit: true,
                        b_row: true,
                        n_w: ic.s(21+1),
                        d_stlLblCtas: {
                          width: ic.s(5),
                        },
                        d_stlLblPfxs: {
                          textAlign: 'center',
                        },
                      })),
                      ce.c(ce.Inp, cf.f('i1zri41i', {
                        key: -20,
                        pfx: '人数',
                        state: 's_i1zri41i',
                        b_edit: true,
                        b_row: true,
                        n_w: ic.s(21+1),
                        d_lbls: {
                          d_stlCtas: {
                            width: ic.s(6),
                          },
                          d_stlPfxs: {
                            textAlign: 'center',
                          },
                        },
                      })),
                    ]),
                    ce.c(ce.Row, {
                      key: -40,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(0.2),
                    }, [
                      ce.c(ce.Pck, cf.f('i1zrb41f', {
                        key: -10,
                        pfx: '室',
                        state: 's_i10r_fst',
                        b_edit: true,
                        b_row: true,
                        ld_iss: global.t?.state.sdld_i10rSlcListsss?.i10r,
                        o_onChg: _d_dats => {
                          if (_d_dats) {
                            let _i10r_fst = _d_dats?.d_flds?._fst;
                            i10v1a.op_loadDtl({
                              elm: 'i10r',
                              fst: _i10r_fst,
                            })
                            .then(() => {
                              let _i11r_fst = _d_dats?.d_flds?.i10rb51f;
                              i11v1a.op_loadSlcList({
                                elm: 'i110',
                                i11r_fst: _i11r_fst,
                              })
                              .then(() => {
                                global.t?._op_loadCdr();
                              })
                            })
                          }
                          else { // 削除した場合
                            global.t?.setState({
                              sdld_i10rListsss: {i10r:[]},
                              sdld_i110SlcListsss: {i110:[]},
                            }, () => {
                              global.t?._op_loadCdr();
                            })
                          }
                        },
                        n_w: ic.s(21+1),
                        d_stlLblCtas: {
                          width: ic.s(5),
                        },
                        d_stlLblPfxs: {
                          textAlign: 'center',
                        },
                      })),
                      _r3,
                    ]),

                    ce.c(ce.Row, {
                      key: -60,
                      n_w: ic.s(64),
                      n_mgnTop: ic.s(0.3),
                    }, [
                      ce.c(ce.Inp, cf.f('i1zri51s', {
                        key: -10,
                        state: 's_i1zri51s',
                        b_edit: true,
                        b_row: true,
                        n_w: ic.s(21+1),
                        d_stlLblCtas: {
                          width: ic.s(5),
                        },
                        d_stlLblPfxs: {
                          textAlign: 'center',
                        },
                      })),
                    ]),

                  ]),

                  ce.c(ce.Lbl, {
                    key: -55,
                    pfx: '予約状況',
                    b_vsb: (ff.f(global.t?.state.sdld_i10rListsss?.i10r)) ? true : false,
                    d_stlCtas: {
                      marginTop: ic.s(1), // 20211202
                    },
                    stlLbl: {
                    },
                  }),
                  ce.c(ce.Row, {
                    key: -60,
                    n_mgnTop: ic.s(0.2),
                  }, _r2)

                ],
              },
              d_btms: {
                l_clds: [
                  ce.c(ce.Box, {
                    key: -10,
                    stlCta: {
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      width: ic.gn_bdyW - ic.m(2),
                      maxWidth: ic.gn_minBdyW * 2,
                      marginTop: ic.s(0.5), // 20211202
                      marginBottom: ic.s(0.5), // 20211202
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }
                  }, [
                    ce.c(ce.Btn, {
                      key: -20,
                      pfx: '前の画面に戻る',
                      stlBtn: {
                        width: ic.s(8),
                        backgroundColor: ic.g_ccdHN,
                        borderColor: ic.g_ccdHN,
                      },
                      o_onPrs: () => {
                        let _d_pageInfs = {
                          sgc_pageRole: global.t?.state.sgc_pageRole,
                          sgc_pageName: 'i1zv1a',
                          sgc_pageMode: 'show',
                        }; 
                        cf.myRN_move_fwd(_d_pageInfs);
                      },
                    }),
                    ce.c(ce.Btn, {
                      key: -30,
                      pfx: 'この内容で予約を一括登録',
                      stlBtn: {
                        width: ic.s(13),
                      },
                      o_onPrs: () => {
                        global.t?.$opb_chk()
                        .then( _b_res => {
                          if (_b_res) { // op_upd の一部抜粋
                            cf.s();
                            Promise.all(
                              global.t?.$clp_upds()
                            )
                            .then(()=>{
                              global.t?.op_loadListAll()
                              .then(() => {
                                alert('登録が完了しました。')
                                cf.h();
                              });
                            });
                          };
                        })
                      },
                    }),
                  ])
                ]
              }
            }),

          ],
        }
      }
    )
  );
}

}
